<template>
    <div class="body-list-group">
        <div class="item-matter"
             @click.stop="submitMatter(matterItem)"
             @contextmenu.prevent.stop="submitOperate(matterItem, {}, $event)"
             v-for="matterItem in groupMatters">
            <div class="icon-top my-cursor" v-show="matterItem.info.iconIsTop"></div>
            <div class="priority-border">
                <div class="priority-item" :style="{backgroundColor: 'var(--color-priority-'+ matterItem.info.priority +')'}"></div>
            </div>
            <div class="row-item">
                <div class="row-matter-title">
                    <div class="my-cursor"
                         :class="{
                        'icon-clock': matterItem.timeInfo.state <= 0,
                        'icon-clock-true': matterItem.timeInfo.state === 1,
                        'icon-clock-false': matterItem.timeInfo.state === 2
                         }"
                         :style="{backgroundColor: 'var(--color-priority-'+ matterItem.info.priority +')'}"
                        @click.stop="submitClock(matterItem, {})">
                    </div>
                    <div class="text-matter-title" :class="{'text-title-clocked': matterItem.timeInfo.state > 0}">
                        {{ matterItem.info.title }}
                    </div>
                </div>
                <div class="row-matter-date">
                    <template v-if="matterItem.timeInfo.state <= 0">
                        <template v-if="matterItem.info.isWaiting">
                            <div class="button-set-today my-cursor" @click.stop="submitToDay(matterItem)">移到今天</div>
                            <div class="button-set-date my-cursor" @click.stop="submitSetDate(matterItem)">设定日期</div>
                        </template>
                        <template v-else>
                            <div class="text-matter-date" :style="{color: matterItem.timeInfo.state === -1 ? '#EA3323': '#666666'}">{{ matterItem.timeInfo.dateText }}</div>
                            <div class="text-matter-time">{{ matterItem.timeInfo.timeText }}</div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="text-matter-date">{{ matterItem.timeInfo.dateText }}</div>
                    </template>
                    <div class="icon-matter-remind" v-show="matterItem.info.iconIsRemind"></div>
                    <div class="icon-matter-repeat" v-show="matterItem.info.iconIsRepeat"></div>
                    <div class="my-cursor"
                         :class="[
                             {'icon-put-away': openChildArray.indexOf(matterItem.info.inventoryId) === -1},
                             {'icon-put-open': openChildArray.indexOf(matterItem.info.inventoryId) > -1}
                             ]"
                         @click.stop="setOpenChildArray(matterItem.info.inventoryId)"
                         v-if="matterItem.childArray.length > 0">
                    </div>
                </div>
                <div class="row-matter-child"
                     @click.stop=""
                     v-if="matterItem.childArray.length > 0 && openChildArray.indexOf(matterItem.info.inventoryId) > -1">
                    <div class="child-item"
                         @contextmenu.prevent.stop="submitOperate(matterItem, childItem, $event)"
                         v-for="childItem in matterItem.childArray">
                        <div class="row-child-title">
                            <div class="my-cursor"
                                 :class="{
                                'icon-clock': childItem.timeInfo.state <= 0,
                                'icon-clock-true': childItem.timeInfo.state === 1,
                                'icon-clock-false': childItem.timeInfo.state === 2
                                 }"
                                 :style="{backgroundColor: 'var(--color-priority-'+ matterItem.info.priority +')'}"
                                 @click.stop="submitClock(matterItem, childItem)">
                            </div>
                            <div class="text-child-title" :class="{'text-title-clocked': childItem.timeInfo.state > 0}">{{ childItem.info.title }}</div>
                        </div>
                        <div class="row-child-date" v-if="childItem.timeInfo.state > 0">
                            <div class="text-matter-date">{{ childItem.timeInfo.dateText }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
export default {
    name: "MatterGroup",

    computed: {
        ...mapState("listModules", {
            openChildArray: state => state.openChildArray,
        })
    },
    props:{
        groupMatters: {
            type: Array,
            default: ()=> [],
        },
    },
    methods: {
        ...mapMutations('listModules', ["setOpenChildArray"]),
        submitOperate: function(matterItem, childItem, e){
            this.$emit("operateEvent", {matterItem: matterItem, childItem: childItem, mouseX: e.x, mouseY: e.y});
        },
        submitClock: function(matterItem, childItem){
            console.log(childItem);
            this.$emit("clockEvent", {matterItem: matterItem, childItem: childItem})
        },
        submitMatter: function(matterItem){
            this.$emit("matterEvent", matterItem)
        },
        submitToDay: function(matterItem){
            this.$emit("toDayEvent", matterItem)
        },
        submitSetDate: function(matterItem){
            this.$emit("setDateEvent", matterItem)
        },
    },
}
</script>

<style scoped>
div.item-matter {
    width: 100%;
    min-height: 0.76rem;
    border-radius: 0.16rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;
    position: relative;
    background: #FFFFFF;
    margin-bottom: 0.16rem;
}


div.icon-top {
    width: 0.28rem;
    height: 0.38rem;
    background: url("../../../../assets/images/List/icon-top.png") no-repeat;
    background-size: cover;
    position: absolute;
    right: 0.5rem;
    top: -0.25rem;
    z-index: 2;
}

div.priority-border {
    width: calc(100% + 0.04rem);
    height: calc(100% + 0.04rem);
    position: absolute;
    margin-left: -0.02rem;
    margin-top: -0.02rem;
    border-radius: 0.16rem;
    border: 0.02rem solid transparent;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 1;
}
div.priority-item{
    width: 0.08rem;
    height: 100%;
}


div.row-item{
    height: auto;
    padding: 0.14rem 0.24rem;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
}

div.row-matter-title {
    width: 100%;
    height: 0.25rem;
    box-sizing: border-box;
    margin-bottom: 0.04rem;
    display: flex;
    gap: 0.12rem;
}



div.icon-clock, div.icon-clock-true, div.icon-clock-false {
    width: 0.25rem;
    height: 0.25rem;
}

div.icon-clock {
    mask: url("../../../../assets/images/List/icon-clock.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-true {
    mask: url("../../../../assets/images/List/icon-clock-true.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-false {
    mask: url("../../../../assets/images/List/icon-clock-false.png") no-repeat;
    mask-size: cover;
}

div.text-matter-title, div.text-child-title{
    flex: 1;
    height: 0.25rem;
    font-family: PF-Regular, sans-serif;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.25rem;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
div.text-child-title{
    font-weight: 400;
}
div.row-matter-date, div.row-child-date{
    width: 100%;
    height: 0.25rem;
    padding-left: 0.36rem;
    box-sizing: border-box;

    font-family: PF-Regular, sans-serif;
    font-size: 0.15rem;
    color: #666666;
    line-height: 0.25rem;
    text-align: left;
}
div.text-matter-date, div.text-matter-time, div.button-set-today, div.button-set-date{
    float: left;
    margin-right: 0.1rem;
}
div.button-set-today, div.button-set-date {
    width: 0.66rem;
    height: 0.25rem;
    box-sizing: border-box;
    border: 0.01rem solid #000000;
    font-size: 0.13rem;
    line-height: 0.23rem;
    text-align: center;
    border-radius: 0.14rem;
}

div.icon-matter-remind, div.icon-matter-repeat{
    width: 0.14rem;
    height: 0.14rem;

    float: left;
    margin-right: 0.05rem;
    margin-top: 0.06rem;
}
div.icon-matter-remind{
    background: url("../../../../assets/images/List/icon-remind.png") no-repeat;
    background-size: cover;
}
div.icon-matter-repeat{
    background: url("../../../../assets/images/List/icon-repeat.png") no-repeat;
    background-size: cover;
}
div.icon-put-open,div.icon-put-away{
    width: 0.18rem;
    height: 0.18rem;
    float: right;
    margin-top: 0.04rem;
}
div.icon-put-open{
    background: url("../../../../assets/images/List/icon-put-open.png");
    background-size: cover;
}
div.icon-put-away{
    background: url("../../../../assets/images/List/icon-put-away.png");
    background-size: cover;
}
div.row-matter-child{
    width: 100%;
    padding-left: 0.36rem;
    box-sizing: border-box;
}
div.child-item{
    margin-top: 0.16rem;
}
div.row-child-title{
    height: 0.25rem;
    box-sizing: border-box;
    display: flex;
    gap: 0.12rem;
}


div.text-title-clocked{
    color: #999999;
    text-decoration-line: line-through;
}
</style>